import { LogoNaverSymbol } from '@/components/svgIcon'
import { IProductMallLink } from '@/types/interfaces/products'
import Image from 'next/image'

export default function ProductDetailRelatedProducts({
  mallLinks,
}: {
  mallLinks: IProductMallLink[]
}) {
  const products = mallLinks
    .filter(product => /^https?:\/\//i.test(product.linkUrl))
    .sort((a, b) => a.order - b.order)

  if (!products.length) {
    return null
  }

  return (
    <section className="mt-6 border-t border-gray-100 pt-10">
      <h2 className="text-lg font-bold">이 체험과 함께 구매하기</h2>
      <p className="mt-2 text-[13px] text-gray-400">
        체험과 연계된 로컬 상품을 네이버 스마트스토어에서 만나보세요..
      </p>
      <div className="mt-6 grid gap-4 sm:grid-cols-3">
        {products.map(product => (
          <a
            key={product.id}
            href={product.linkUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="overflow-hidden rounded-2xl border border-gray-100 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-emerald-500"
          >
            <div className="relative aspect-[1.65] bg-gray-100">
              {product.thumbnail && (
                <Image
                  src={product.thumbnail}
                  alt={product.title}
                  fill
                  unoptimized
                  className="object-cover"
                />
              )}
            </div>
            <div className="p-3">
              <h3 className="text-[15px] font-semibold">
                {product.title}
                <span className="sr-only"> (새 창)</span>
              </h3>
              {product.description && (
                <p className="mt-1 text-[13px] text-gray-500">{product.description}</p>
              )}
              <div className="mt-2 flex flex-wrap items-center gap-3">
                <strong className="text-[15px]">
                  {Number.isFinite(Number(product.price.replaceAll(',', '')))
                    ? `${Number(product.price.replaceAll(',', '')).toLocaleString('ko-KR')}원`
                    : product.price}
                </strong>
                <span className="inline-flex items-center gap-[4px] rounded-full bg-[#00C300] px-2 py-[3px] text-[12px] text-white">
                  <LogoNaverSymbol className="size-3" />
                  스토어
                </span>
              </div>
            </div>
          </a>
        ))}
      </div>
    </section>
  )
}
